import { render, staticRenderFns } from "./ReporteInnactividadMaquinas.vue?vue&type=template&id=c21d71f4&"
import script from "./ReporteInnactividadMaquinas.vue?vue&type=script&lang=js&"
export * from "./ReporteInnactividadMaquinas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports